import { Button } from '../Button';

import {
  BannerActions,
  BannerTitle,
  BannerDescription,
  BannerContent,
  BannerRoot,
} from './banner.parts';

export const Banner = {
  Root: BannerRoot,
  Content: BannerContent,
  Title: BannerTitle,
  Description: BannerDescription,
  Actions: BannerActions,
  Action: Button,
} as const;
